import { render } from "./TradingPost.vue?vue&type=template&id=6f324b92"
import script from "./TradingPost.vue?vue&type=script&lang=js"
export * from "./TradingPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__